import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { Chip } from './ConvivialComponents';

export default function CityFilter({ cities, selectedCity, onChange }) {
    if (cities.length === 0) return null;

    return (
        <Box sx={{ minWidth: 0 }}>
            <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 800, textTransform: 'uppercase' }}>
                Per città
            </Typography>
            <Stack direction="row" spacing={1} sx={{ mt: 1, overflowX: 'auto', pb: 0.5, '& .MuiChip-root': { flexShrink: 0 } }}>
                {['all', ...cities].map((city) => (
                    <Chip key={city} selected={selectedCity === city} clickable onClick={() => onChange(city)} aria-pressed={selectedCity === city}>
                        {city === 'all' ? 'Tutte' : city}
                    </Chip>
                ))}
            </Stack>
        </Box>
    );
}
